// «Как Вы себя видите» — design workspace screen (pwa-design@insights) on
// the engine self-view cards: numbered list. Hide (§2.8 rule 8) applies.

import { useInsightsData } from '../model/useInsightsData'
import InsightsGate from './InsightsGate'
import InsightsEmpty from './InsightsEmpty'
import InsightsTabBar from './InsightsTabBar'
import HideButton from './HideButton'
import styles from './NumberedCards.module.css'
import { BEFORE_PAYMENT_EMPTY } from './beforePaymentCopy'

const GROWS_NOTE = 'Раздел будет дополняться автоматически после ваших следующих разговоров'

export default function SelfView() {
  const insights = useInsightsData()
  return (
    <>
      <InsightsGate insights={insights}>
        {insights.data && (
          <div className={styles.page}>
            <h1 className={styles.title}>Как Вы себя видите</h1>
            <p className={styles.lead}>Что прозвучало в ваших разговорах.</p>
            {insights.data.self_view.length === 0 ? (
              <InsightsEmpty
                title="Здесь пока пусто"
                text={insights.data.before_payment ? BEFORE_PAYMENT_EMPTY.self_view : 'Здесь появится то, что вы рассказываете о себе в разговорах. Пока диалогов ещё не было — начните первый, и мы соберём их для вас.'}
              />
            ) : (
              <ol className={styles.list}>
                {insights.data.self_view.map((item, index) => (
                  <li key={item.id} className={styles.card}>
                    <span className={styles.index} aria-hidden="true">{`${String(index + 1).padStart(2, '0')}.`}</span>
                    <div className={styles.body}>
                      <h2 className={styles.cardTitle}>{item.title}</h2>
                      <p className={styles.cardText}>{item.text}</p>
                    </div>
                    <HideButton
                      onHide={() => { void insights.hide('self_view', item.id) }}
                      busy={insights.hiding === `self_view/${item.id}`}
                    />
                  </li>
                ))}
              </ol>
            )}
            {insights.data.notes.self_view_grows && insights.data.self_view.length > 0 && (
              <p className={styles.growsNote}>{GROWS_NOTE}</p>
            )}
          </div>
        )}
      </InsightsGate>
      <InsightsTabBar />
    </>
  )
}
